export default {
  LOAD_LIST(state, data) {
    state.listEncargos = data
  },
  PREPARE_TO_EDIT(state, data) {
    state.encargo = data
  },
  RESET(state) {
    state.encargo = {
      id: null,
      nome: '',
      valor: 0,
      tipoEncargo: 'FIXO',
      planoDeConta: null,
      ativo: true
    }
  }
}
